// eslint-disable-next-line import/no-anonymous-default-export
export default {
    'title': 'Terms and Conditions',
    'overview': 'Accept all mandatory terms and conditions in order to continue',
    'check': {
        'message': 'You must accept all the mandatory terms for the use of the service'
    }
}
